import axios from "./Api";
import { handleQueriesString } from "../helpers/function.helper";

export const ChangeStatusProduct = async (isLocked: boolean, id: string) => {
  const status = isLocked ? "un-lock-product" : "lock-product";
  const url = `/api/app/product/${status}/${id}`;
  const data = await axios.post(url);
  return data;
};

export const GetInventoryProduct = async (params: any) => {
  const url = `/api/app/inventory-history/search`;
  const data = await axios.post(url, params);
  return data;
};

export const GetProductList = async (params: any,pageSize?:number) => {
  if(!pageSize)pageSize=40;
  const queriesString = handleQueriesString(params);
  const url = `/api/app/product?MaxResultCount=${pageSize}&${queriesString}`;
  const data = await axios.get(url);
  return data;
};
export const GetExcelList = async (params: any) => {
  const url = `/api/app/excel/get-stock-amount-listby-filter`;
  const data = await axios.post(url, params, { responseType: "blob" });
  return data;
};

export const ReturnToProduct = async (id: string) => {
  const url = `/api​/app​/product​/${id}​/resolve-returned-item`;
  const data = await axios.post(url);
  return data;
};
